module.exports = __webpack_public_path__ + "static/media/Right fist top.af557d26.svg";